import { EVENT_VIEW_ACCESSORY } from '~~/constants/googleTagManager';
import type { ViewAccessoryItems, EcommerceViewAccessory } from '~~/types/integrations/tagManager/TagViewAccessory';

export const buildViewAccessoryTags = ({
  parentProductId,
  viewAccessoryItems,
}: {
  parentProductId: string;
  viewAccessoryItems: ViewAccessoryItems;
}) => ({
  event: EVENT_VIEW_ACCESSORY,
  ecommerce: {
    detail: {
      parent_product_id: parentProductId,
      items: viewAccessoryItems,
    },
  } as EcommerceViewAccessory,
});
